export const SET_USERTOKEN = 'SET_USERTOKEN';
export const SET_USERINFO = 'SET_USERINFO';
export const SET_LOGOUTTIMEOUT = 'SET_LOGOUTTIMEOUT';
export const SET_USERPERMISSIONS = 'SET_USERPERMISSIONS';